webpackJsonp([64923267097583],{

/***/ 1802:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"HfdProgramCode","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"code","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"insertedAt","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"A program code issued by HFD, selected when an invoice is sent to HFD.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-hfd-program-code-540af9d1bd5b0cac508e.js